import packageJson from '../../package.json';

const BASE_URL = 'https://dev-terralego-onf.makina-corpus.net';

/**
 * Default settings
 */
const defaultSettings = {
  SITE_NAME: 'Demande d\'autorisation ONF',
  VERSION: packageJson.version,
  BASE_URL,
  API_URL: `${BASE_URL}/api`,
  CMS_URL: `${BASE_URL}/cms`,
  SOURCE_VECTOR_URL: `${BASE_URL}/api/layer`,
  REFRESH_TOKEN: 3540000, // moment.duration(59, 'minutes'),
  PAGE_SIZE: 50,
  MAPBOX_ACCESS_TOKEN: 'pk.eyJ1IjoibWFraW5hY29ycHVzIiwiYSI6ImNqY3E4ZTNwcTFta3ozMm80d2xzY29wM2MifQ.Nwl_FHrWAIQ46s_lY0KNiQ',

  BASE_RASTERLAYER: [ // Valid URL from MapboxGL raster layer tiles
    'https://wxs.ign.fr/rt4c7at1ondaw43yz761j6qc/geoportail/r/wms?&SERVICE=WMS&REQUEST=GetMap',
    'LAYERS=SCAN25TOUR_PYR-JPEG_WLD_WM',
    'VERSION=1.3.0&STYLES=normal&FORMAT=image%2Fjpeg&TRANSPARENT=true',
    'WIDTH=256&HEIGHT=256&CRS=EPSG:3857&BBOX={bbox-epsg-3857}',
  ].join('&'),
};

const prefixFiltering = scope => (acc, curr) => {
  const [, prefix, key] = /(.{10})(.*)/.exec(curr) || [];
  return prefix === 'REACT_APP_' ? { ...acc, [key]: scope[curr] } : acc;
};

/**
 * Generate envSettings from `process.env` variables prefixed by `REACT_APP_`
 */
const envSettings = Object.keys(process.env).reduce(prefixFiltering(process.env), {});

/**
 * Generate injectedSettings from `window` variables prefixed by `REACT_APP_`
 */
const injectedSettings = Object.getOwnPropertyNames(window).reduce(prefixFiltering(window), {});

/**
 * Merge both objects
 */
export default {
  ...defaultSettings,
  ...envSettings,
  ...injectedSettings,
};



// WEBPACK FOOTER //
// ./src/front-settings/index.js